<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
body,
p,
div,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
ol {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* {
  font-weight: 400;
}
a {
  outline: none;
  text-decoration-color: #fd8317;
  text-decoration: underline;
}
ul li {
  list-style: none;
}
.clear:after {
  contain: "";
  display: table;
  clear: both;
}

.clearfix:after{
content:"";//设置内容为空
height:0;//高度为0
line-height:0;//行高为0
display:block;//将文本转为块级元素
visibility:hidden;//将元素隐藏
clear:both//清除浮动
}
.clearfix{
zoom:1;//为了兼容IE
}
.floatR {
  float: right;
}
.floatL {
  float: left;
}
i{
  font-style: normal;
}
.bx {
  margin: 0 auto;
  width: 1100px;
}
 .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #cda769 !important;
    color: #ffffff !important;
    // span {
    //   display: inline-block;
    //   width: 56px;
    //   height: 40px;
    // }
  }
// .el-dialog__body  {
//     padding: 20px 20px 0px !important;
//   }
  .el-pager li {
    margin: 0 4px;
    padding: 0 4px;
    background: #FFF;
    color: #000000;
    font-size: 14px;
    min-width: 30px !important;
    height: 30px !important;
    line-height: 30px !important;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.el-pager li.active {
    background-color: #f0c179;
    color: #fff !important;
    cursor: default;
    border-radius: 50%;
}
.el-pagination__total {
    margin-right: 10px;
    font-weight: 400;
    color: #000000;
}
 .el-select-dropdown__list {
    list-style: none;
    padding: 6px 0;
    margin: 0;
    box-sizing: border-box;
    text-align: center !important;
  }

  
.active_1 {
  display: block !important;
  background-color: #d69e48 !important;
  box-shadow: 0px 3px 10px rgba(226, 197, 152, 0.35);
  color: #ffffff !important;
  border-radius: 5px;
  width: 140px !important;
  line-height: 50px;

  &::after {
    position: absolute;
    content: "";
    width: 3px;
    height: 100%;
    right: -10px;
    background-color: #d69e48;
  }
}
// .el-dialog {
//   left: 50%;
//   top: 30%;
//   transform: translate(-50%, -30%);
//   margin: 0px !important;
// }
// .el-menu-vertical-demo:not(.el-menu--collapse) {
//     width: 9.94rem;
//     min-height: 100vh;
//   }
.shop-page > .header .left{
  font-size: 20px ;
  font-weight: bold;
}
.el-menu-vertical-demo{
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue